import { Icon } from "@iconify/react"
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { Button, Card, Flex, Grid, Input, Pagination, Table, Tag } from "antd"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { customerService } from "../../../services/customer.service";
import useTitleStore from "../../../store/titleStore";
import { useTableHeight } from "../../../hooks/useTableHeight";
import useDebounce from "../../../hooks/useDebounce";

export default function UserManagementIndex() {

  const breakpoint = Grid.useBreakpoint()

  const navigate = useNavigate();

  const { setTitle } = useTitleStore();

  const tableHeight = useTableHeight();

  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500);
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    query: debouncedKeyword
  })

  useEffect(() => {
    setTitle("Pengguna");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataParams((prev) => ({
      ...prev,
      query: debouncedKeyword
    }));
  }, [debouncedKeyword]);

  const { data: customerData, isLoading, isRefetching } = useQuery({
    queryKey: ['customers', dataParams],
    queryFn: () => customerService.fetchAll(dataParams),
    placeholderData: keepPreviousData,
  })


  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page
    })
  }

  const customer = customerData?.data;
  const pagination = customerData?.pagination || { total: 0, page: 1 };

  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 80,
      fixed: breakpoint.md && 'left',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Nama',
      dataIndex: 'name',
      width: 180,
      fixed: breakpoint.md && 'left',
    },
    {
      title: 'Alamat Email',
      dataIndex: 'email',
      width: 210
    },
    {
      title: 'No Handphone',
      dataIndex: 'phone',
      width: 150
    },
    {
      title: 'Tanggal Verifikasi',
      dataIndex: 'verifiedAt',
      width: 150,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: val => val ? <Tag color="green" >Aktif</Tag> : <Tag color="red" >Non Aktif</Tag>,
      width: 120,
    },
    {
      className: 'last-cell-p',
      title: 'Aksi',
      align: 'right',
      width: 120,
      fixed: 'right',
      render: record => (
        <Button
          icon={<Icon icon="solar:eye-bold-duotone" width="18" height="18" />}
          color="primary"
          variant="filled"
          onClick={() => {
            return navigate(`/user-management/user-account/detail/${record.id}`)
          }}
          size=""
        />
      )
    },
  ]

  return (
    <>
      <Card
        styles={{
          body: {
            paddingLeft: 0,
            paddingRight: 0
          }
        }}
      >
        <Flex gap={20} justify="space-between" style={{ paddingInline: 24, marginBottom: 24 }} >
          <Input
            style={{ width: 320 }}
            prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
            placeholder="cari berdasarkan nama, no handphone atau email"
            onChange={e => setKeyword(e.target.value)}
            value={keyword}
          />
        </Flex>
        <Table
          columns={columns}
          size="small"
          loading={isLoading || isRefetching}
          rowKey={'id'}
          scroll={{ y: tableHeight }}
          dataSource={customer}
          pagination={false}
        />
        <Pagination
          style={{ marginInline: 24, marginTop: 16 }}
          total={pagination.total}
          showSizeChanger={{
            showSearch: false,
          }}
          pageSizeOptions={['10', '20', '50']}
          current={pagination.page}
          pageSize={dataParams.limit}
          align="end"
          onChange={handleChangePage}
        />
      </Card>
    </>
  )
}